module.exports = __webpack_public_path__ + "img/icon_bu.2db2486c.png";